import React, { useContext, useState } from "react";
import { AuthFetch } from "../../services/api";
import { notify } from "../../utils/utils";
import { UserContext } from "../../context/provider/UserProvider";

const urlBaseBIM = process.env.REACT_APP_TMAN_API + '/BIM'

export const useBIM = () => {
    const { stateUser , signOut } = useContext(UserContext);

    const codEmpresa = stateUser.codEmpresa
    
    const incidenteDefault = {
        codEmpresa: codEmpresa,
        codUnidad: 0,
        codPersonaConductor: 0,
        comentarioBim: "",
        codUsuarioAccion: stateUser.codUsuario,
        
        codBitacoraIncidenciaMantenimiento: 0,
    }

    const [incidente,setIncidente] = useState(incidenteDefault)
    const [incidentes,setIncidentes] = useState([])
    const [documentoActual,setDocumentoActual] = useState(0)

    const listarBIM = async (fechaInicio,fechaFin) => {
        const response = await AuthFetch({
            url: urlBaseBIM + '?' + new URLSearchParams({
                codEmpresa: codEmpresa,
                codUsuario: stateUser.codUsuario,
                fechaInicio: fechaInicio, 
                fechaFin: fechaFin,
            })
        })
        if(response.isValid){
            setIncidentes(response.content)
        }else{
            notify(response.exceptions[0].description,'error')
        }
    }

    const registrarEditarBIM = async () => {
        const esGuardar = incidente.codBitacoraIncidenciaMantenimiento === 0
        const {codBitacoraIncidenciaMantenimiento,...jsonGuardar} = incidente
        const response = await AuthFetch({
            url: urlBaseBIM,
            method: esGuardar ? 'POST' : 'PUT',
            body: JSON.stringify(esGuardar ? jsonGuardar : incidente)
        })
        
        return {
            CodResultado: response.isValid ? 1 : 0,
            DesResultado: response.isValid ?  response.content : response.exceptions[0].description
        }
    }

    const eliminarBIM = async (motivoAnulacion) => {
        const response = await AuthFetch({
            url: urlBaseBIM,
            method: 'DELETE',
            body: JSON.stringify({
                codEmpresa: codEmpresa,
                codBitacoraIncidenciaMantenimiento: incidente.codBitacoraIncidenciaMantenimiento,
                motivoAnulacion: motivoAnulacion,
                codUsuarioAccion: stateUser.codUsuario
            })
        })
        
        return {
            CodResultado: response.isValid ? 1 : 0,
            DesResultado: response.isValid ? response.content : response.exceptions[0].description
        }
    }

    const mostrarDocumentoActual = async () => {
        const response = await AuthFetch({
            url: urlBaseBIM + '/currentNumbering?' + new URLSearchParams({
                codEmpresa: codEmpresa,
                codUsuario: stateUser.codUsuario
            })
        })
        if(response.isValid){
            setDocumentoActual(response.content.nroDocumento)
        }else{
            notify(response.exceptions[0].description,'error')
        }
    }





    
    const editarValorIncidencia = (key,value) => {
        setIncidente(valorAnterior => {
            return{
                ...valorAnterior,
                [key]: value
            }
        })
    }
    
    
    return {
        incidenteDefault,
        incidente,
        setIncidente,
        listarBIM,
        incidentes,
        registrarEditarBIM,
        eliminarBIM,
        mostrarDocumentoActual,
        documentoActual,
        editarValorIncidencia
    }
};
